import { useEffect, useState } from "react";
import api from "@/lib/api";
import { formatDate } from "@/lib/constants";

const MODE = { correction: "Korrektur", sale: "Eigentümerwechsel" };

export default function OwnerHistoryList({ propertyId, refreshKey }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!propertyId) return;
    api.get(`/properties/${propertyId}/owner-history`).then(({ data }) => setItems(data.items || [])).catch(() => setItems([]));
  }, [propertyId, refreshKey]);
  if (!items.length) return null;
  return (
    <div className="mt-3 pt-3 border-t border-slate-100" data-testid="owner-history-list">
      <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold mb-1.5">Eigentümer-Historie</div>
      <div className="space-y-1">
        {items.map((h, i) => (
          <div key={`${h.at}-${i}`} className="text-xs text-slate-600" data-testid={`owner-history-item-${i}`}>
            <span className="font-medium text-slate-800">{formatDate(h.effective_date || h.at)}</span>
            {" · "}{MODE[h.mode] || h.mode}: {h.old_owner_name || "—"}{h.old_owner_number ? ` #${h.old_owner_number}` : ""}
            {" → "}<span className="font-medium">{h.new_owner_name}{h.new_owner_number ? ` #${h.new_owner_number}` : ""}</span>
            {h.renumbered?.length > 0 && <span className="text-slate-400"> · {h.renumbered.length} Vertragsnr. umnummeriert</span>}
            {h.note && <span className="text-slate-400"> · {h.note}</span>}
          </div>
        ))}
      </div>
    </div>
  );
}
